export default function mobileMenu() {
	let body = $('body');
	let mobileMenu = $('#mobile-navigation');
	let backdrop = mobileMenu.find('> .backdrop');
	let menu = mobileMenu.find('> .menu');
	let menuTemplate = document.getElementById('mobile-navigation-content-template');
	let initialized = false;

	let initialize = function () {
		if(initialized || !menuTemplate) {
			return;
		}

		initialized = true;
		menu.get(0).appendChild(menuTemplate.content.cloneNode(true));
	};

	let close = function () {
		body.removeClass('navbar-active');
	};

	backdrop.click(close);

	$('#menu').click(() => {
		initialize();
		mobileMenu.css('display', '');
		setTimeout(() => body.addClass('navbar-active'), 1);
	});
}
